export default __webpack_public_path__ + "static/media/taras.438cb1eb.jpg";